export default __webpack_public_path__ + "static/media/wewillbeokay.39f512f4.gif";